'use strict';
var React = require('react');
var ReactRedux = require('react-redux');
var BaseComponent = require('../../../../../shared/base');
var Moment = require('moment');
const Currency = require('currency-symbol-map');
const PurchaseTableContents = require('./' +  process.env.PRICING_TYPE + '/index');
let client = require('../../../../../../../sdk/client');
var commonModule = require('../../../../../../public/js/common');
var PurchaseSearchComponent = require('../../../../../purchase/history/purchase-search');

const sortTypes = {
    up: {
        class: 'sort-up'
    },
    down: {
        class: 'sort-down'
    },
    default: {
        class: 'sort'
    }
    
};
class FeaturePurchaseOrderListB2cComponent extends PurchaseTableContents {

    constructor(props){
        super(props)
       var pagg;
        if (typeof window !== 'undefined') {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString);
            const pagination = urlParams.get('pagination');
            if(pagination) {
                console.log("index,jsx1 Pagination arrived: " + pagination);
                pagg = pagination;

                setTimeout(function(index){
                    // console.log('final click');
                    var options = document.getElementsByClassName('pagination')[0].getElementsByClassName('numeros');
                    options[0].getElementsByTagName('a')[0].click();
                    options[0].className = "numbers";
                }.bind(this), 2000);
            } else {
                // console.log("index1,jsx1 else");
                pagg = 0;
            }
        } else {
            // console.log("index,jsx1 No windows yet");
            pagg = 0;
        } 

        this.state = {
            displayData: this.props.Records,
            tableData:[],
            perPage: 20,
            pages: [],
            currentPage: pagg,
            totalQtty: 0,
            totalPrice: 0,
            pagination: pagg,
            endDateFilter: null,
            startDateFilter: null,
            orderedBy: "",
            currentSort: 'default'
        }
        Moment.locale('es');
    }

    componentDidMount(){
            //alert('FeaturePurchaseOrderListB2cComponent')    
    }
    
    componentWillReceiveProps(nextProps){
        if(nextProps.Records !== this.state.displayData){
            this.setState({
                displayData: nextProps.Records
            });
        }
    }

    getLatestOrderStatus(cartItem) {
        let status = "";
        let orderStatuses = cartItem.Statuses.filter(s => s.Type === 'Order');

        if (process.env.CHECKOUT_FLOW_TYPE === 'b2c') {
            orderStatuses = cartItem.Statuses.filter(s => s.Type === 'Fulfilment');
        }

        if (orderStatuses.length > 0) {
            orderStatuses.sort((a, b) => (a.CreatedDateTime > b.CreatedDateTime) ? 1 : -1)
            status = orderStatuses[orderStatuses.length - 1].Name;
        } else if (orderStatuses.length === 0) {
            let fulfillmentStatuses = cartItem.Statuses.filter(s => s.Type === 'Fulfilment');
            if (fulfillmentStatuses.length > 0) {
                status = fulfillmentStatuses[fulfillmentStatuses.length - 1].Name;
            }
        } 
        /*switch (status) {
            case 'Ready For Consumer Collection':
                status = 'Ready for Pick-up';
                break;
            case 'Delivered':
                if (cartItem.BookingSlot != 'undefined' && cartItem.BookingSlot != null) {
                    status = 'Shipped';
                }
                break;
        }*/

        switch (status) {
            case 'Acknowledged':
                status = 'Recibido';
                break;
            case 'Collected':
                status = 'Fincado';
                break;
            case 'Delivered':
                /*
                ??
                if (cartItem.BookingSlot != 'undefined') {
                    status = 'Enviado';
                }*/
                status = 'En Surtimiento';
                break;
            case 'Completed':
                status = 'Facturado';
                break;
            case 'Cancelled':
                status = 'Cancelado';
                break;
            case 'Created':
                status = 'Recibido';
                break;
            /*
            This case status doesn't work, it never updates his status
                case 'Ready For Consumer Collection':
                status = 'Facturado';
                break;
            */
        }
        return status;
    }

    //                                                      //DEPRECADO - PONER EL HEADER DE LA PAGINA
    renderHeader() {
        //console.log("todos los pedidos")
        //console.log(this.props.Records)
        if (typeof this.renderCustomHeader == 'function') return this.renderCustomHeader();
        return (
            <thead>
                <tr>
                    <th>No. de pedido</th>
                    <th>Fecha</th>
                    <th>Estatus</th>
                    <th>Tipo de pedido</th>
                    <th>Total</th>
                    <th>Folio</th>
                </tr>
            </thead>
        );
    }

    //                                                      //ORDENAMIENTO REGISTROS
    orderBy(column){
        const self = this;
        let arrOrderedData = this.state.displayData;
        let nextSort;
        if(this.state.orderedBy !== column){
            nextSort = 'up';
            /* CASE START*/
            if(column === "no-pedido"){
                arrOrderedData.sort((a, b) => (a.Orders[0].PurchaseOrderNo > b.Orders[0].PurchaseOrderNo) ? 1 : -1);
            } else if(column === "fecha"){
                arrOrderedData.sort((a, b) => (self.formatDateTime(a.Orders[0].CreatedDateTime, 'DD/MM/YYYY hh:mm a') > self.formatDateTime(b.Orders[0].CreatedDateTime, 'DD/MM/YYYY hh:mm a')) ? 1 : -1);
            } else if(column === "estatus"){
             //   arrOrderedData.sort((a, b) => (a.OrderID > b.OrderID) ? 1 : -1);
            } else if(column === "tipo"){
            //    arrOrderedData.sort((a, b) => (a.OrderType > b.OrderType) ? 1 : -1);
            } else if(column === "total"){
                arrOrderedData.sort((a, b) => (self.formatMoney(a.Orders[0].CurrencyCode, a.Orders[0].GrandTotal) > self.formatMoney(b.Orders[0].CurrencyCode, b.Orders[0].GrandTotal)) ? 1 : -1);
            } else if(column === "referencia"){
                arrOrderedData.sort((a, b) => (a.InvoiceNo > b.InvoiceNo) ? 1 : -1);
            }
            /* CASE END */
            var pagg;
            if (typeof window !== 'undefined') {
                const queryString = window.location.search
                const urlParams = new URLSearchParams(queryString);
                const pagination = urlParams.get('pagination');
                if(pagination) {
                    console.log("index,jsx Pagination arrived: " + pagination);
                    pagg = pagination;
                } else {
                    console.log("index,jsx else");
                    pagg = 0;
                }
            } else {
                console.log("index,jsx No windows yet");
                pagg = 0;
            } 

            this.setState({
                currentPage:pagg,
                tableData:arrOrderedData,
                displayData: arrOrderedData.slice(pagg*this.state.perPage, (pagg+1)*this.state.perPage),
                orderedBy: column,
                currentSort: nextSort
            });
        } else {
            nextSort = 'down';
            /* CASE START*/
            if(column === "no-pedido"){
                arrOrderedData.sort((a, b) => (a.Orders[0].PurchaseOrderNo < b.Orders[0].PurchaseOrderNo) ? 1 : -1);
            } else if(column === "fecha"){
                arrOrderedData.sort((a, b) => (self.formatDateTime(a.Orders[0].CreatedDateTime, 'DD/MM/YYYY hh:mm a') < self.formatDateTime(b.Orders[0].CreatedDateTime, 'DD/MM/YYYY hh:mm a')) ? 1 : -1);
            } else if(column === "estatus"){
             //   arrOrderedData.sort((a, b) => (a.OrderID > b.OrderID) ? 1 : -1);
            } else if(column === "tipo"){
            //    arrOrderedData.sort((a, b) => (a.OrderType > b.OrderType) ? 1 : -1);
            } else if(column === "total"){
                arrOrderedData.sort((a, b) => (self.formatMoney(a.Orders[0].CurrencyCode, a.Orders[0].GrandTotal) < self.formatMoney(b.Orders[0].CurrencyCode, b.Orders[0].GrandTotal)) ? 1 : -1);
            } else if(column === "referencia"){
                arrOrderedData.sort((a, b) => (a.InvoiceNo < b.InvoiceNo) ? 1 : -1);
            }
            /* CASE END */

            column = column + "rev";

            var pagg;
            if (typeof window !== 'undefined') {
                const queryString = window.location.search
                const urlParams = new URLSearchParams(queryString);
                const pagination = urlParams.get('pagination');
                if(pagination) {
                    console.log("index,jsx Pagination arrived: " + pagination);
                    pagg = pagination;
                } else {
                    console.log("index,jsx else");
                    pagg = 0;
                }
            } else {
                pagg = 0;
                console.log("index,jsx No windows yet");
            } 

            this.setState({
                currentPage: pagg,
                tableData:arrOrderedData,
                displayData: arrOrderedData.slice(pagg*this.state.perPage, (pagg+1)*this.state.perPage),
                orderedBy: column,
                currentSort: nextSort
            });
        }
    }


    //                                                                  //HEADER DE LA PAGINA DE BUSQUEDA
    renderHeadersort() {
        if (typeof this.renderCustomHeader == 'function') return this.renderCustomHeader();
        const { user } = this.props;
        const showTipoDePedido = user && user.userType === 'B2C';
        return (
            <thead>
                <tr>
                    <th>No. de pedido<button className="btnsort" onClick={() => this.orderBy("no-pedido")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Fecha<button className="btnsort" onClick={() => this.orderBy("fecha")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Estatus<button className="btnsort" onClick={() => this.orderBy("estatus")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    {showTipoDePedido && <th>Tipo de pedido<button className="btnsort" onClick={() => this.orderBy("tipo")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>}
                    <th>Total<button className="btnsort" onClick={() => this.orderBy("total")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Referencia<button className="btnsort" onClick={() => this.orderBy("referencia")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                </tr>
            </thead>
           
        );
    }

    //                                                                      //ESCRIBE DETALLE DE COLUMNA ESTATUS
    renderCustomListItemContent(contentCode, invoice) {
        if (contentCode == 'BOOKING_DETAILS') {
            if (typeof this.renderBookingDetails == 'function') {
                return this.renderBookingDetails(invoice);
            }
        }
        return;
    }

    //                                                                     //BUSCAR LOS ELEMENTOS SELECCIONADOS
    filterData(e) {
        let noPedido = document.getElementById("keywords").value;
        var values = $('#filter-datepicker').val();
        var statuses = "";
        var startDate;
        var endDate;
        var arrOrders = [];
        var status = "";

        $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Realizando búsqueda, por favor espere.'});

        if (typeof this.props.user !== 'undefined') {
            if (this.props.user && this.props.user.Guest === true && CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                this.props.user.ID = CommonModule.getCookie("guestUserID");
            }
        } 

        if(values  !== "Rango de fechas"){
            var dtstart = values.split("-")[0].trim();
            var dtEnd = values.split("-")[1].trim();
            startDate = Moment(dtstart, 'DD/MM/YYYY').startOf('day').utc().unix();
            endDate = Moment(dtEnd, 'DD/MM/YYYY').endOf('day').utc().unix();
        } 
        
        $('#dropdown-status').find("input[type='checkbox']:checked").each(function (index, element) {
            var id = $(this).attr('id');
            var label = $(this).prop("labels");
            var text = $(label).text();            
            if (id !== "status_0")
                statuses += text + ',';                
        });

        if(statuses){
            status = this.setStatuses(statuses);
            status = status.substring(0, status.length-1);
            $('#selectedStatusOptionFilter').text(status);
        }
        
        //fulfilment status es el que se utiliza para filtrar por status, ya viene previamente traducido
        let filtros = {
            pageSize: 20, 
            pageNumber: 1, 
            keyword: noPedido, 
            startDate: startDate,
            endDate: endDate, 
            status: status,
            fulfilmentStatuses: status,
            userID: this.props.user.ID
        }

        let fechas = {
            StartDate: startDate,
            EndDate: endDate
        }


        //                                                          //Actualiza keyword, star5tDate, endDate y status en la store de la pagina
        this.props.updateKeyword(noPedido);
        this.props.updateSelectedDates(fechas);
        this.props.updateSelectedOrderStatus(status)
        //                                                          //Realiza la busqueda con los filtros establecidos
        this.props.searchPurchaseFulfilment(filtros);
    }
    
    //                                                  //CAMBIA LISTA DE ESTATUS DE BUSQUEDA AL INGLES
    setStatuses(statuses){
        //                                          //
        var status = "";
        let arrStatus = statuses.split(",");
        for (let index = 0; index < arrStatus.length - 1; index++) {
            const element = arrStatus[index];
            if(element =="En surtimiento"){
                status += "delivered" + ",";
            }else  if(element =="Fincado"){
                status += "collected" + ",";
            }else  if(element =="Recibido"){
                status += "acknowledged" + ",";
            }else  if(element =="Cancelado"){
                status += "cancelled" + ",";;
            }else  if(element =="Facturado"){
                status += "completed" + ",";
            }
        } 
        return status;  
    }

    //                                                          //LIMPIAR FILTROS DE BUSQUEDA CON BOTON RESTABLECER
    clearFilters() {    
        $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Realizando búsqueda, por favor espere.'});
        //                                                      //limpiando los campos de filtros
        var $control =  $('.advanced-select .x-check input[type=checkbox]').parents('.advanced-select');
        $control.removeClass('choosen')
        $('#selected-status-option-filter').text('');
        $('#filter-datepicker').val('Rango de fechas');
        $('#filter-datepicker').removeClass('filled');
        $('#keywords').val('');
        $('#status').val('Estatus de pedido');
        $('#dropdown-status').find("input[type='checkbox']:checked").each(function (index, element) {
            $(this).prop("checked", false);
           
        });
        $('.cont-choose').removeClass('choosen')
        this.setState({
            displayData: this.props.Records
        });

        //                                                      //realiza busqueda con filtros vacios
        this.filterData(null);
    }

    //                                                          //CONSTRUYE DROPDOWN DE ESTATUS BASADO EN ESTATUS
    renderStatuses() {
        //                                                      //Se cambian nombres al espanol
        const self = this;
        const records = self.props.statuses;
        let statuses = [
            {Name: "completed"},//facturado 
            {Name: "collected"},//fincado
            {Name: "acknowledged"},//recibido o pagado
            {Name: "cancelled"},//cancelado
            {Name: "delivered"}//En surtimiento
        ]
        if (statuses) {
            return (<ul className="dropdown-menu" id="dropdown-status">
                <li className="skip-li"><input type="text" className="q" placeholder="Buscar Status" /></li>
                <li><a className="x-check parent-check" href="#"><input type="checkbox" name="status_0" id="status_0" />
                    <label htmlFor="status_0"> Seleccionar todo</label></a></li>
                {
                    statuses.map(function (obj, index) {
                        if (obj.Name && obj.Name.toLowerCase() === "delivered") {
                            obj.Name = "En surtimiento"
                        }
                        else if (obj.Name && obj.Name.toLowerCase() === "collected") {
                            obj.Name = "Fincado"
                        }
                        else if (obj.Name && obj.Name.toLowerCase() === "acknowledged") {
                            obj.Name = "Recibido"
                        }
                        else if (obj.Name && obj.Name.toLowerCase() === "cancelled") {
                            obj.Name = "Cancelado"
                        }
                        else if (obj.Name && obj.Name.toLowerCase() === "completed") {
                            obj.Name = "Facturado"
                        }
                        
                        return <li key={index}><a className="x-check" href="#">
                        <input type="checkbox" data-status-id={obj.Name} name={obj.Name} id={obj.Name} /><label htmlFor={obj.Name}>{obj.Name}</label></a></li>
                    })
                }
            </ul>)
        } else {
            ""
        }
    }

    //                                                              //PREPARA SECCION DE BUSQUEDA
    renderFilters(){
        return(
            <div>
                <div className="sc-upper">
                    <div className="sc-u title-sc-u sc-u-mid full-width m-change">
                            <span className="sc-text-big">Historial de ordenes</span> 
                            {/*<small>{this.props.TotalRecords || 0} registros</small>*/}
                        <div className="mobile-only">
                             {/*   <PageItemCountComponent onChange={this.handlePageSizeChange} value={this.state.pageCount} /> */}
                        </div>
                    </div>
                </div>
                <div className="sassy-filter lg-filter">
                    <form action="" id="search">
                        <div className="sassy-flex">
                            <div className="sassy-l" style={{width: '100%'}}>
                                <div>
                                    <div className="group-search" style={{width: '100%'}}>
                                        <div className="">
                                            <div id="filters-container-OH" className="row">
                                                <div className="col-3 container-search" style={{display: 'grid'}}>
                                                    <label htmlFor="" className="lbl-title-filter-option">Filtrar por No. de pedido:</label>
                                                    <span id="input-search" className="sassy-search input-filter-option">
                                                            <input style={{border:'none', width:'85%'}} type="text" className="form-control inputsearch" name="keywords" id="keywords" placeholder="Buscar..."  defaultValue={this.props.keyword}  />
                                                    </span>
                                                </div>
                                                {<div className="col-3 container-options" style={{display: 'grid'}}>
                                                    <label className="lbl-title-filter-option">Intervalo de fechas:</label>
                                                    <div className="filter-list-date-sec sassy-datepicker input-filter-option">
                                                        <div className="group-datepicker" id="container-input-datepicker" style={{textAlign: 'unset !important',textAlign: 'left !important' }}>
                                                            <input type="text" name="timestamp" id="filter-datepicker" placeholder="Fecha" data-default="DD/MM/AA - DD/MM/AA"/>
                                                            
                                                        </div>
                                                    </div>
                                                </div>}
                                                
                                                <div className="col-3 container-options" style={{display: 'grid'}}>
                                                    <label className="lbl-title-filter-option">Estatus</label>
                                                    
                                                    <span className="select-sassy-wrapper input-filter-option" id="inputEstatus">
                                                        <div id="cont-choose"className="advanced-select" data-model="Status Selected">
                                                            <div className="dropdown">
                                                                <input className="trigger selector-status" id="status" type="button" data-default="Estatus de pedido" value={this.props.orderStatusSearchLabel} name="OrderStatusSearchLabel" />
                                                                
                                                                <a href="#" className="btn-toggle" data-toggle="dropdown" aria-expanded="true"></a>
                                                                
                                                                <a href="#" className="x-clear"><i className="fa  fa-times-circle" /><span id='selected-status-option-filter'>AQUI</span></a>
                                                                    {this.renderStatuses()}
                                                            </div>
                                                        </div>
                                                    </span>
                                                </div>

                                                <div id="container-btn-order-hist" className="col-3" style={{display: 'flex'}}>
                                                    <input type="submit" className="btn btn-sassy btn-order-history" id="btnApply"  value="Filtrar" onClick={(e) => this.filterData()}/>
                                                    <input type="submit" style={{marginLeft:"15px"}} className="btn btn-sassy btn-order-history" value="Restablecer" onClick={() => this.clearFilters()}></input>
                                                </div>
                                            </div>
                                            
                                        
                                            {/*
                                            <span className="select-sassy-wrapper">
                                                <div className="advanced-select" data-model="Supplier Selected">
                                                    <div className="dropdown">
                                                        <input id="supplier" type="button" data-default={supplierStr} value={this.props.supplierSearchLabel}  className="trigger" name="Supplier" name="SupplierSearchLabel" />
                                                        <a href="#" className="btn-toggle" data-toggle="dropdown" aria-expanded="true"><b className="caret" /></a>
                                                        <a href="#" className="x-clear"><i className="fa  fa-times-circle" /></a>
                                                            {this.renderSupplier()}
                                                    </div>
                                                </div>
                                            </span>
                                            */}
                                           { }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {  /*  <PageItemCountComponent onChange={this.handlePageSizeChange} value={this.state.pageCount} /> */}
                        </div>
                    </form>
                </div>
            </div>
            
        )
    }

    render() {
        const self = this;
        const { user } = this.props;
        const showTipoDePedido = user && user.userType === 'B2C';
        if (this.state.displayData) {
            return (
                <React.Fragment>
                    {this.renderFilters()}
                    <input id="paginationNo" name="paginationNo" type="hidden"/>
                    <div className="subaccount-data-table table-responsive">
                        {/*<table className="table order-data1 sub-account tb-left clickable">*/}
                        <table id="table-history-order" className=" table-arrows table sub-account tb-left clickable">
                            {
                           // this.renderHeader()
                            this.renderHeadersort()
                            }
                            <tbody>
                                {
                                    this.state.displayData.map(function (obj, index) {
                                        //ARC8930 need to adjust here, since the FailedTransaction is using the same Manager as PO here
                                        if (obj.Orders && obj.Orders[0].PaymentDetails && obj.Orders[0].PaymentDetails[0].Status === "Processing" || 
                                            obj.Orders && obj.Orders[0].PaymentDetails && obj.Orders[0].PaymentDetails[0].Status === "Failed" ||
                                            obj.Orders && obj.Orders[0].PaymentDetails && obj.Orders[0].PaymentDetails[0].Status === "Created")
                                            return ""

                                        return <tr className="account-row " data-key="item" data-id={1}>
                                            <td><a className="no-order" id="paginationNumber" href={"/purchase/detail/" + obj.InvoiceNo + "/merchant/" + obj.Orders[0].MerchantDetail.ID + "?pagination="}>{obj.Orders[0].CosmeticNo != null && obj.Orders[0].CosmeticNo != "" ? obj.Orders[0].CosmeticNo : obj.Orders[0].PurchaseOrderNo}</a></td>
                                            <td><a id="paginationNumber" href={"/purchase/detail/" + obj.InvoiceNo + "/merchant/" + obj.Orders[0].MerchantDetail.ID + "?pagination="}>{self.formatDateTime(obj.Orders[0].CreatedDateTime, 'DD/MM/YYYY hh:mm a')}</a></td>
                                            {/*<td><a href={"/purchase/detail/" + obj.InvoiceNo + "/merchant/" + obj.Orders[0].MerchantDetail.ID}>{obj.Orders[0].MerchantDetail.DisplayName}</a></td>*/}
                                            {
                                                obj.Orders[0].CartItemDetails ? 
                                                    <td>{self.getLatestOrderStatus(obj.Orders[0].CartItemDetails[0]) ? self.getLatestOrderStatus(obj.Orders[0].CartItemDetails[0]) : "N / A"}</td>
                                                    : <td> N/A </td> 
                                            }


                                            {self.renderCustomListItemContent('BOOKING_DETAILS', obj)}
                                            {showTipoDePedido && <td>{self.resolveOrderType(obj.Orders[0])}</td>}
                                            <td>
                                                <div className="item-price test" style={{float: 'left'}}>
                                                    <span className="currencyCode"></span>
                                                    <span className="currencySymbol"></span>
                                                    <span className="priceAmount">{self.formatMoney(obj.CurrencyCode, obj.Total)}</span>
                                                </div>
                                            </td>

                                            <td>{obj.Orders[0].PaymentDetails[0].CosmeticNo ? obj.Orders[0].PaymentDetails[0].CosmeticNo : obj.InvoiceNo}</td>
                                            
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                </React.Fragment>
            );
        } else {
            return "";
        }

    }

    resolveOrderType(
        Order_I
        )
    {
        let orderTypes = "-";
        let arrOrderTypes = [];
        if (
            Order_I.CartItemDetails.length > 0
            )
        {
            let uniqueOrderTypes = [];
            Order_I.CartItemDetails.forEach(cartItemDetail => {
                if (
                    cartItemDetail.CustomFields != undefined
                    )
                {
                    let cfItemDetail = cartItemDetail.CustomFields.find(cf => cf.Name == "OrderType");
                    if (
                        cfItemDetail != undefined
                        )
                    {
                        uniqueOrderTypes.push(cfItemDetail.Values[0]);
                    }
                }
            });

            if (
                uniqueOrderTypes.length > 0
                )
            {
                arrOrderTypes = this.arrSortFilter(uniqueOrderTypes);
                orderTypes = this.strOrderTypes(arrOrderTypes);
            }
        }        

        return orderTypes;
    }

    arrSortFilter(
        arrOrderTypes_I
        )
    {
        return arrOrderTypes_I.sort().filter(function(item, pos, ary) {
            return !pos || item != ary[pos - 1];
        });
    }

    strOrderTypes(
        arrOrderTypes_I
        )
    {
        let orderTypes = "";
        for (let indexI = 0; indexI < arrOrderTypes_I.length; indexI++) {
            const orderType = arrOrderTypes_I[indexI];
            orderTypes += orderType.slice(0, 1) + orderType.toLowerCase().slice(1, orderType.length);
            if(indexI != arrOrderTypes_I.length - 1)
            {
                orderTypes += ", ";
            }
        }

        return orderTypes;
    }

}

module.exports = FeaturePurchaseOrderListB2cComponent;